import {Component, OnInit} from '@angular/core';
import {TrnBedStatusService} from '../../../../configuration/trn-bed-status/trn-bed-status.service';

@Component({
  selector: 'app-vacant-bed',
  templateUrl: './vacant-bed.component.html',
  styleUrls: []
})
export class VacantBedComponent implements OnInit {
  mipdAllBedList: Array<any> = [];
  tempmipdAllBedList: Array<any> = [];
  mipdAllocatedBedList: Array<any> = [];
  vaccantBedList: Array<any> = [];
  unitid: any;

  constructor(private trnBedStatusService: TrnBedStatusService) {
  }

  ngOnInit() {
    this.unitid = JSON.parse(sessionStorage.getItem('unitId'));
    this.getAllBed();
    //this.getVacantBed();
  }

  getAllBed() {
    this.trnBedStatusService.getOccupiedBedByUnitId(this.unitid)
      .then(resp => {
        this.mipdAllBedList = resp;
        console.log('alocated bed');
        console.log(resp);
      });
  }

// getVacantBed()
// {
//   this.trnAdmissionService.getallocatedbedlist()
//     .then(resp => {
//       resp = resp
//
//       // console.log("vaccant bed");
//       // console.log(resp);
//
//       for(let admg of resp)
//       {
//         for(let single of admg.admissionCurrentBedId)
//         {
//           this.mipdAllocatedBedList.push(single);
//         }
//       }
//
//
//       // console.log("mipdAllocatedBedList bed befor for loop")
//       // console.log(this.mipdAllocatedBedList)
//
//       //  admissionCurrentBedId.bedId
//       for (let i = 0; i < this.mipdAllocatedBedList.length; i++) {
//         for (let j = 0; j < this.mipdAllBedList.length; j++) {
//
//           // console.log("compair")
//
//           // console.log(this.mipdAllocatedBedList[i].bedId);
//           // console.log(this.mipdAllBedList[j].bedId);
//
//           if(this.mipdAllocatedBedList[i].bedId == this.mipdAllBedList[j].bedId )
//           {
//
//             //
//             this.mipdAllBedList = this.mipdAllBedList.filter(item => item.bedId != this.mipdAllocatedBedList[i].bedId);
//             // console.log("available bed")
//
//             // console.log(this.mipdAllBedList);
//           }
//         }
//      }
//
//       // console.log(this.mipdAllBedList);
//
//     });
// }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/ipd/bed-management/under-maintenance/vacant-bed/vacant-bed.component.ts